module.exports = __webpack_public_path__ + "img/arrow-grey.dd69da21.svg";